import { UsersListApiResponse } from '../dtos/responses/users-list-response';
import { userManagementUrl, Users } from '../../../../../constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICreateUserRequest } from '../dtos/requests/create-user.request';
import { IUpdateUserResponse } from '../dtos/responses/update-user-response';
import { UserContextService } from '../../../auth-management/authentication/services/user-context.service';
import { DeprecatedPaginationParameters } from '../../../../../trash/shared/interfaces/shared-interfaces';

@Injectable({
    providedIn: 'root'
})
export class UsersService {
    collectionUrl: string = `${userManagementUrl}/${Users}`;

    constructor(private http: HttpClient) {}

    getAll(params?: DeprecatedPaginationParameters): Observable<UsersListApiResponse> {
        let paramsItem = new HttpParams();
        paramsItem.append('accountId', UserContextService.getUserContext()!.accountId);
        // Loop through the parameters and append them if defined
        if (params) {
            Object.keys(params).forEach(key => {
                const value = (params as any)[key];
                if (value !== undefined && value !== null && value !== '') {
                    paramsItem = paramsItem.append(this.mapParamKey(key), value);
                }
            });
        }

        // Return the HTTP GET call with the expected response type
        return this.http.get<UsersListApiResponse>(`${this.collectionUrl}`, { params: paramsItem });
    }
    // Helper method to map parameter keys if needed (optional)
    private mapParamKey(key: string): string {
        const map: { [key: string]: string } = {
            sortColumn: 'SortColumn',
            sortOrder: 'SortOrder',
            searchField: 'SearchField',
            SearchKeyword: 'SearchKeyword',
            page: 'Page',
            pageSize: 'PageSize',
            order: 'Order',
            orderBy: 'OrderBy'
        };
        return map[key] || key;
    }

    // Create a new resource (POST)
    async create(request: ICreateUserRequest): Promise<Observable<UsersListApiResponse>> {
        return await this.http.post<UsersListApiResponse>(`${this.collectionUrl}`, request);
    }

    // Update a resource (PUT)
    async update(request: ICreateUserRequest, id: number | string): Promise<Observable<IUpdateUserResponse>> {
        return await this.http.put<IUpdateUserResponse>(`${this.collectionUrl}/${id}`, request);
    }
}
